module.exports = __webpack_public_path__ + "images/e5062e7871b8cd000dd33d66b0f25c38.png";